document.addEventListener('DOMContentLoaded', function() {
    const footerTitles = document.querySelectorAll('.footer__title');

    footerTitles.forEach(title => {
        title.addEventListener('click', function() {
            if (window.innerWidth < 992) {
                // Close other open sections
                footerTitles.forEach(otherTitle => {
                    if (otherTitle !== this) {
                        otherTitle.classList.remove('active');
                        const otherContent = otherTitle.nextElementSibling;
                        if (otherContent) {
                            otherContent.classList.remove('active');
                        }
                    }
                });

                this.classList.toggle('active');
                const content = this.nextElementSibling;
                if (content) {
                    content.classList.toggle('active');
                }
            }
        });
    });
});
